/* unplugin-vue-components disabled */import { render } from "./myBottom.vue?vue&type=template&id=dfab682c"
const script = {}

import exportComponent from "F:\\workBench\\my_server_project\\simplecloud-project-resource\\kaola-img\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__